import store from "@/views/loggedPages/Store.vue";
import auth from "@/middleware/Auth";
import notFoundPage from "@/views/sharedPages/404.vue";

export default [
  {
    //aqui tengo que ver que tienda esta seleccionada en el localstorage
    //y redireccionar a /store/storeCode/dashboard o llama a inicializarla
    path: "/store",
    component: store,
    name: "store",
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/store/:storeCode/:departmentCode",
    component: store,
    children: [
      {
        path: "dashboard",
        name: "DashboardPage",
        component: () => import("@/views/loggedPages/DashboardPage.vue")
      },
      {
        // Fast orders_v2-only /orders/list endpoint, promoted to the main
        // /orders route after comparison approval. Keeps the "OrdersPage"
        // route name so existing $router.push({ name: "OrdersPage" }) calls
        // elsewhere keep working unchanged.
        path: "orders",
        name: "OrdersPage",
        component: () => import("@/views/loggedPages/OrdersPage2.vue"),
        meta: { permission: "can_view_orders" }
      },
      {
        // Rollback route: the previous, fully-joined /orders/set-based page.
        // Kept available at /orders2 in case we need to roll back quickly.
        // Safe to remove once the new /orders has been stable for a while.
        path: "orders2",
        name: "OrdersPage2",
        component: () => import("@/views/loggedPages/OrdersPage.vue"),
        meta: { permission: "can_view_orders" }
      },
      {
        // Las cotizaciones se movieron a la vista de órdenes; se mantiene la
        // ruta para enlaces guardados (incluido ?orderOpen=).
        path: "quotes",
        name: "QuotesPage",
        redirect: to => ({
          name: "OrdersPage",
          query: { ...to.query, search: "statusShipment=quotes" }
        })
      },
      {
        path: "infoauto-customers",
        name: "InfoautoCustomersPage",
        component: () =>
          import("@/views/loggedPages/InfoautoCustomersPage.vue"),
        meta: { permission: "can_view_customers" }
      },
      {
        path: "infoauto-orders",
        name: "InfoautoOrdersPage",
        component: () => import("@/views/loggedPages/InfoautoOrdersPage.vue"),
        meta: { permission: "can_sync_infoauto_orders" }
      },
      {
        path: "product/:productCode",
        name: "ProductPage",
        component: () => import("@/views/loggedPages/ProductPage.vue")
      },
      {
        path: "order/:orderNumber",
        name: "OrderPage",
        component: () => import("@/views/loggedPages/OrderPage.vue"),
        meta: { permission: "can_view_orders" }
      },
      {
        path: "order/:orderNumber/packing-manifest",
        name: "PackingManifestPage",
        component: () => import("@/views/loggedPages/PackingManifestPage.vue"),
        meta: { permission: "can_view_orders" }
      },
      {
        path: "trucks",
        name: "TrucksPage",
        component: () => import("@/views/loggedPages/TrucksPage.vue"),
        meta: { permission: "can_edit_store_settings" }
      },
      {
        path: "marketplaces",
        name: "Marketplaces",
        component: () => import("@/views/loggedPages/Marketplaces.vue"),
        meta: { permission: "can_edit_marketplaces_items" }
      },
      {
        path: "pending-products",
        name: "PendingProducts",
        component: () =>
          import("@/views/loggedPages/settings/PendingProducts.vue"),
        meta: { permission: "can_edit_pending_products" }
      },
      {
        path: "taxjar",
        name: "Taxjar",
        component: () => import("@/views/loggedPages/settings/Taxjar.vue")
      },
      {
        path: "taxjar-routes",
        name: "TaxjarRoutes",
        component: () => import("@/views/loggedPages/settings/TaxjarRoutes.vue")
      },
      {
        path: "taxjar-orders",
        name: "TaxjarOrders",
        component: () => import("@/views/loggedPages/settings/TaxjarOrders.vue")
      },
      {
        path: "store-settings",
        name: "StoreSettingsPage",
        component: () => import("@/views/loggedPages/StoreSettingsPage.vue"),
        meta: { permission: "can_edit_store_settings" },
        children: [
          {
            path: "general-settings",
            name: "GeneralSettings",
            component: () =>
              import("@/views/loggedPages/settings/GenericSettingsView.vue"),
            props: {
              section: "general_info",
              title: "General settings"
            }
          },
          {
            path: "critical-zone",
            name: "CriticalZone",
            component: () =>
              import("@/views/loggedPages/settings/GenericSettingsView.vue"),
            props: {
              section: "critical_zone",
              title: "Critical zone"
            }
          },
          {
            path: "admin-settings",
            name: "AdminSettings",
            component: () =>
              import("@/views/loggedPages/settings/GenericSettingsView.vue"),
            props: {
              section: "admin",
              title: "Admin settings"
            }
          },
          {
            path: "orders-settings",
            name: "OrdersSettings",
            component: () =>
              import("@/views/loggedPages/settings/GenericSettingsView.vue"),
            props: {
              section: "order_settings",
              title: "Order settings"
            }
          },
          {
            path: "marketplaces-settings",
            name: "MarketplacesSettings",
            component: () =>
              import("@/views/loggedPages/settings/GenericSettingsView.vue"),
            props: {
              section: "marketplaces",
              title: "Marketplaces settings"
            }
          },
          {
            path: "search-settings",
            name: "SearchSettings",
            component: () =>
              import("@/views/loggedPages/settings/GenericSettingsView.vue"),
            props: {
              section: "search_settings",
              title: "Search settings"
            }
          },
          {
            path: "ai-models",
            name: "AiModelsSettings",
            component: () =>
              import("@/views/loggedPages/settings/AiModelsSettings.vue")
          },
          {
            // Nombre anterior, cuando sólo configuraba el asistente
            path: "ai-assistant",
            redirect: { name: "AiModelsSettings" }
          },
          {
            path: "brands-manager",
            name: "BrandsManager",
            component: () =>
              import("@/views/loggedPages/settings/BrandsManager.vue")
          },
          {
            path: "pop-up-messages",
            name: "PopUpMessages",
            component: () =>
              import("@/views/loggedPages/settings/GenericSettingsView.vue"),
            props: {
              section: "pop_up",
              title: "Pop up settings"
            }
          },
          {
            path: "category-manager",
            name: "CategoryManager",
            component: () =>
              import("@/views/loggedPages/settings/CategoryManager.vue")
          },
          {
            path: "vehicles-manager",
            name: "ManageVehicles",
            component: () =>
              import("@/views/loggedPages/settings/ManageVehicles.vue")
          },
          {
            path: "marketplaces-category-manager",
            name: "MarketplacesCategoryManager",
            component: () =>
              import(
                "@/views/loggedPages/settings/MarketplacesCategoryManager.vue"
              )
          },
          {
            path: "coupons-manager",
            name: "CouponsManager",
            component: () =>
              import("@/views/loggedPages/settings/CouponsManager.vue")
          },
          {
            path: "banners-manager",
            name: "BannersManager",
            component: () =>
              import("@/views/loggedPages/settings/BannersManager.vue")
          },
          {
            path: "parts-settings-manager",
            name: "PartsSettings",
            component: () =>
              import("@/views/loggedPages/settings/PartsSettings.vue")
          },
          {
            path: "sitemaps-manager",
            name: "SitemapsManager",
            component: () =>
              import("@/views/loggedPages/settings/SitemapsManager.vue")
          },
          {
            path: "google-ads",
            name: "GoogleAds",
            component: () =>
              import("@/views/loggedPages/settings/GoogleAds.vue")
          },
          {
            path: "price-groups",
            name: "PriceGroups",
            component: () =>
              import("@/views/loggedPages/settings/PriceGroups.vue")
          },
          {
            path: "catalog-pricing",
            name: "CatalogPricing",
            component: () =>
              import("@/views/loggedPages/settings/CatalogPricing.vue")
          },
          {
            path: "bulk-product-upload/:uploadId?",
            name: "BulkProductUpload",
            component: () =>
              import("@/views/loggedPages/settings/BulkProductUpload.vue")
          },
          {
            path: "image-batch-upload",
            name: "ImageBatchUpload",
            component: () =>
              import("@/views/loggedPages/settings/ImageBatchUpload.vue")
          },
          {
            path: "popular-products",
            name: "PopularProducts",
            component: () =>
              import("@/views/loggedPages/settings/PopularProducts.vue")
          },
          {
            path: "other-procedures",
            name: "OtherProcedures",
            component: () =>
              import("@/views/loggedPages/settings/OtherProcedures.vue")
          },
          {
            path: "carrier-services",
            name: "CarrierServices",
            component: () =>
              import("@/views/loggedPages/settings/CarrierServices.vue")
          },
          {
            path: "local-delivery",
            name: "LocalDelivery",
            component: () =>
              import("@/views/loggedPages/settings/LocalDelivery.vue")
          },
          {
            path: "departments-manager",
            name: "DepartmentsManager",
            component: () =>
              import("@/views/loggedPages/settings/DepartmentsManager.vue")
          },
          {
            path: "department-priority",
            name: "DepartmentPriority",
            component: () =>
              import("@/views/loggedPages/settings/DepartmentPriority.vue")
          },
          {
            path: "price-lists-manager",
            name: "PriceListsManager",
            component: () =>
              import("@/views/loggedPages/settings/PriceListManager.vue")
          },
          {
            path: "infoauto",
            name: "Infoauto",
            component: () => import("@/views/loggedPages/settings/Infoauto.vue")
          }
        ]
      },
      {
        path: "resale-tax",
        name: "ResaleTax",
        component: () => import("@/views/loggedPages/settings/ResaleTax.vue"),
        meta: { permission: "resale_tax_management" }
      },
      {
        path: "supersession-manager",
        name: "SupersessionManagerPage",
        component: () =>
          import("@/views/loggedPages/SupersessionManagerPage.vue"),
        meta: { permission: "can_edit_supersession" }
      },
      {
        path: "warehouses",
        name: "WarehousesPage",
        component: () => import("@/views/loggedPages/WarehousesPage.vue")
      },
      {
        path: "carriers",
        name: "CarriersPage",
        component: () => import("@/views/loggedPages/CarriersPage.vue")
      },
      {
        path: "users",
        name: "UsersPage",
        component: () => import("@/views/loggedPages/UsersPage.vue"),
        meta: { permission: "manage_users" }
      },
      {
        path: "map",
        name: "MapPage",
        component: () => import("@/views/loggedPages/MapPage.vue"),
        meta: { roles: ["superadmin"] }
      },
      {
        path: "user/:userId",
        name: "UserPage",
        component: () => import("@/views/loggedPages/UserPage.vue"),
        meta: { permission: "manage_users" }
      },
      {
        path: "payments",
        name: "PaymentsPage",
        component: () => import("@/views/loggedPages/PaymentsPage.vue"),
        meta: { permission: "can_view_web_payments" }
      },
      {
        path: "pos-payments",
        name: "PosPaymentsPage",
        component: () => import("@/views/loggedPages/PosPaymentsPage.vue"),
        meta: { permission: "can_view_pos_payments" }
      },
      {
        path: "alerts",
        name: "AlertsPage",
        component: () => import("@/views/loggedPages/AlertsPage.vue"),
        meta: { roles: ["superadmin"] }
      },
      {
        path: "uploads",
        name: "uploadsPage",
        component: () => import("@/views/loggedPages/UploadsPage.vue"),
        meta: { permission: "can_upload_files" }
      },
      {
        path: "report-generator",
        name: "reportGenerator",
        component: () => import("@/views/loggedPages/ReportGenerator.vue"),
        meta: { permission: "can_request_report" }
      },
      {
        path: "statistics",
        name: "StatisticsPage",
        component: () => import("@/views/loggedPages/StatisticsPage.vue"),
        meta: { permission: "can_view_statistics" }
      },
      {
        path: "wholesale-statistics",
        name: "WholesaleStatisticsPage",
        component: () =>
          import("@/views/loggedPages/WholesaleStatisticsPage.vue"),
        meta: { permission: "can_view_wholesale_statistics" }
      },
      {
        path: "part-search",
        name: "ProductsSearchPage",
        component: () => import("@/views/loggedPages/ProductsSearchPage.vue")
      },
      {
        // part-search ya busca en Typesense. Se conserva la ruta para no
        // romper los enlaces que ya se compartieron.
        path: "part-search-ts",
        redirect: to => ({
          name: "ProductsSearchPage",
          params: to.params,
          query: to.query
        })
      },
      {
        path: "returns",
        name: "ReturnsPage",
        component: () => import("@/views/loggedPages/ReturnsPage.vue"),
        meta: { permission: "can_view_returns" }
      },
      {
        path: "chat",
        name: "ChatPage",
        component: () => import("@/views/loggedPages/ChatPage.vue"),
        meta: { permission: "can_view_chat" }
      },
      {
        path: "form-customer",
        name: "FormSellerCustomerPage",
        component: () =>
          import("@/views/loggedPages/FormSellerCustomerPage.vue"),
        meta: { permission: "can_view_forms" }
      },
      {
        path: "form-submission/:submissionId",
        name: "FormSubmissionDetailsPage",
        component: () =>
          import("@/views/loggedPages/FormSubmissionDetailsPage.vue"),
        meta: { permission: "can_view_forms" }
      },
      {
        path: "image-generator",
        name: "ImageGeneratorPage",
        component: () => import("@/views/loggedPages/ImageGeneratorPage.vue"),
        meta: { permission: "can_use_ia_features" }
      },
      {
        path: "*",
        name: "notFound",
        component: notFoundPage
      }
    ],
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  }
];
